/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'quote-not-accepted': {
    width: 11,
    height: 8,
    viewBox: '0 0 11 8',
    data: '<g _stroke="#E77474" _fill="none" fill-rule="evenodd" stroke-linecap="square" stroke-linejoin="bevel"><path pid="0" d="M3.878 1.785c.536 1.654-.279 2.848-2.444 3.58l2.626 1.99M.996 1.357H5.81M6.516 4.478h3.704M8.368 2.626V6.33"/></g>'
  }
})
